export default __webpack_public_path__ + "static/media/cambriab.3907f97e.ttf";